<template>
    <project-template>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Borgle</h1>
          <p>Development story coming soon.</p>
          <br><p> In the meantime, play today's Borgle board <a href="https://borgle.xyz" target="_blank">here</a>!</p>
        </project-text>

        <project-video
        size="75"
        videoID="852197591"
        :gif="true"/>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectVideo from '../../components/project/ProjectVideo.vue'
import ProjectText from '../../components/project/ProjectText.vue'

export default {
  components: { ProjectTemplate, ProjectText, ProjectVideo }
}
</script>

<style lang="scss" scoped>

</style>
